import { gql } from '@apollo/client';

export const GET_VIREMENTS = gql`
  query GET_VIREMENTS(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: [ApplicationStatus!]
  ) {
    virements(ids: $ids, projectIds: $projectIds, status: $status) {
      id
      date
      fromBudget {
        id
        budgetCategory {
          id
          name
        }
      }
      toBudget {
        id
        budgetCategory {
          id
          name
        }
      }
      amount
      status
    }
  }
`;

export const GET_VIREMENT = gql`
  query GET_VIREMENT(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: [ApplicationStatus!]
  ) {
    virements(ids: $ids, projectIds: $projectIds, status: $status) {
      id
      date
      fromBudget {
        id
        budgetCategory {
          id
          name
        }
      }
      toBudget {
        id
        budgetCategory {
          id
          name
        }
      }
      amount
      status
      approvalRoute {
        sequence
        appointedApprover {
          role {
            id
            name
          }
          faculty {
            id
            name
          }
          department {
            id
            name
          }
        }
        approvalSteps {
          sequence
          name
          approverListingType
          appointedApprover {
            role {
              id
              name
            }
            faculty {
              id
              name
            }
            department {
              id
              name
            }
          }
          approver {
            id
            netId
            name
          }
          approved
          comment
          date
        }
      }
    }
  }
`;

export const ADD_VIREMENT = gql`
  mutation ADD_VIREMENT($input: AddVirementInput!) {
    addVirement(input: $input) {
      id
      fromBudget {
        id
      }
      toBudget {
        id
      }
    }
  }
`;

export const SUBMIT_VIREMENT = gql`
  mutation SUBMIT_VIREMENT($input: SubmitVirementInput!) {
    submitVirement: submitVirement(input: $input) {
      id
      status
    }
  }
`;

export const SUBMIT_VIREMENT_WITH_CUSTOM_DATE = gql`
  mutation SUBMIT_VIREMENT_WITH_CUSTOM_DATE(
    $input: SubmitVirementWithCustomDateInput!
  ) {
    submitVirement: submitVirementWithCustomDate(input: $input) {
      id
      status
    }
  }
`;

export const UPDATE_VIREMENT = gql`
  mutation UPDATE_VIREMENT($input: UpdateVirementInput!) {
    updateVirement(input: $input) {
      id
    }
  }
`;

export const CANCEL_VIREMENT = gql`
  mutation CANCEL_VIREMENT($input: CancelVirementInput!) {
    cancelVirement(input: $input) {
      id
      status
    }
  }
`;

export const DELETE_VIREMENT = gql`
  mutation DELETE_VIREMENT($input: DeleteVirementInput!) {
    deleteVirement(input: $input) {
      id
      status
      fromBudget {
        id
      }
      toBudget {
        id
      }
    }
  }
`;

export const APPROVE_VIREMENT = gql`
  mutation APPROVE_VIREMENT($input: ApproveVirementInput!) {
    approveVirement(input: $input) {
      id
      status
    }
  }
`;
